import {
  accountBalance,
  accountBalanceForChildren,
  allBalance,
  allBalanceForChildren,
  casinoBalance,
  casinoBalanceForChildren,
  virtualBalance,
  virtualBalanceForChildren,
} from "../../js/api/profile.js";
import { getagents } from "../../js/api/getAgents.js";
import { getAccountBalanceTemplate } from "../templates/accountBalance.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

let role = "";
let accountStartDate;
let accountEndDate;
let today = new Date();
let dd = String(today.getDate()).padStart(2, "0");
let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
let yyyy = today.getFullYear();

today = yyyy + "-" + mm + "-" + dd;
let startDate = today;
let endDate = today;

let AccountBalance = {
  render: async () => {
    role = localStorage.getItem("role");

    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));

      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}">${coin.currency}</option>`;
      });
    }

    let agents = await getagents(startDate, endDate, userCoins[0]);
    let agentsView = "";

    if (agents && agents.children_users.length !== 0) {
      const allIds = agents.children_users.map((a) => a.id);
      const uniqueIds = [...new Set(allIds)];
      uniqueIds.forEach((agentId) => {
        const agent = agents.children_users.find((a) => a.id === agentId);
        agentsView += `<option value="${agent.id}">${agent.username}</option>`;
      });
    }

    // const account_balance = await accountBalance(startDate, endDate);

    // if (account_balance) {
    //   if (account_balance.length > 0) {
    //     account_balance.forEach((accBalance) => {
    //       accountBalanceView =
    //         accountBalanceView + getAccountBalanceTemplate(accBalance, role);
    //     });
    //   } else {
    //     accountBalanceView =
    //       accountBalanceView + getAccountBalanceTemplate(account_balance, role);
    //   }
    // }

    let view = /*html*/ `
            <div class="w-full flex flex-row flex-wrap items-center justify-center">
                <div class="p-1 w-full flex flex-row flex-wrap">
                    <div class="w-full flex flex-row flex-wrap bg-black/40 space-x-2 items-center p-2 border-b border-[#3d3d3d]">
                        <a class="flex backBtn w-[24px] h-[24px] max-w-[calc(100%-24px)] border-r">
                            <svg class="py-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                        </a>
                        <span class="text-white text-center font-bold flex-1 text-[14px]">${_t(
                          "Financa"
                        )}</span>
                    </div>
                    <div class="flex flex-row flex-wrap w-full items-center bg-black/40 border-b border-[#3d3d3d] justify-between">
                        <div class="accountBalanceFilter flex flex-row flex-wrap space-x-2 items-center p-2 justify-center">
                            <span class="text-white text-[12px] text-center ">Filtro me date:</span>
                            <input type="text" readonly class="form-control text-[12px] p-1 bg-[#333] border-0 text-white cursor-pointer" id="myCalendar">
                        </div>
                        <div class="myBetsAdministrationFilter flex flex-row flex-wrap space-x-2 items-center p-2 justify-center ${
                          role == "User" || role == "Agent" ? "dontAllow" : ""
                        }">
                            <span class="text-white text-[12px] text-center">Zgjidh nje perdorues:</span>
                            <select class="text-[12px] p-1 bg-[#333] border-0 text-white cursor-pointer" name="accountAgentSelect " id="accountAgentSelect">
                                <option value="">${_t(
                                  "Zgjidhni nje perdorues"
                                )}</option>
                                ${agentsView}
                            </select>
                        </div>
                        <div class="myBetsAdministrationFilter flex flex-row flex-wrap space-x-2 items-center p-2 justify-center ${
                          role == "User" || role == "Agent"
                            ? "makeFullWidth"
                            : ""
                        }">
                            <span class="text-white text-[12px] text-center">${_t(
                              "Zgjidh valuten:"
                            )}</span>
                            <select class="text-[12px] p-1 bg-[#333] border-0 text-white cursor-pointer" name="" id="accountBalanceUserCoinSelect">
                                ${userCoinsView}
                            </select>
                            <span class="text-white text-[12px] text-center">${_t(
                              "Zgjidh llojin:"
                            )}</span>
                            <select class="text-[12px] p-1 bg-[#333] border-0 text-white cursor-pointer" name="accountTypeSelect" id="casinoAccountSelect">
                                <option value="">${_t("ALL")}</option>
                                <option value="1">${_t("Sport")}</option>
                                <option value="2">${_t("Casino")}</option>
                                <option value="3">${_t(
                                  "Virtual Games"
                                )}</option>
                            </select>   
                        </div>
                    </div>
                    <div class="accountBalanceWrapper bg-gradient-to-t from-[#232323] to-[#494949] w-full flex flex-wrap flex-row p-4 ${
                      role != "User" ? "agentColumn" : ""
                    }">
                        <div class="accountBalanceContent flex flex-wrap flex-row w-full">
                            <div class="accountBalanceContentHeader w-full grid grid-cols-5 m-t-6 hidden superMenagerHeader">
                                ${
                                  role != "User"
                                    ? ` <span class="text-center">Info</span>`
                                    : `<span class="text-center">*</span>`
                                }
                                <span  class="text-center">${_t("Xhiro")}</span>
                                <span  class="text-center">${_t(
                                  "Fitimi"
                                )}</span>
                                <span  class="text-center">${_t(
                                  "Jackpot"
                                )}</span>
                                ${
                                  role != "User"
                                    ? `<span  class="text-center">%</span>`
                                    : ""
                                }
                                ${
                                  role != "User"
                                    ? ` <span  class="text-center">${_t(
                                        "Diferenca"
                                      )}</span>`
                                    : ""
                                }
                                ${
                                  role == "User"
                                    ? ` <span  class="text-center">${_t(
                                        "Diferenca"
                                      )}</span>`
                                    : ""
                                }
                            </div>
                            <div class="accountBalanceRows w-full flex flex-wrap flex-row" id="accountBalanceTbl"></div>
                            ${
                              role != "User"
                                ? `<div class="accountBalanceContentHeader w-full flex flex-wrap flex-row-6 m-t-6 " id="accountBalanceContentFooter"></div>`
                                : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    $("body").addClass("full-screen");

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let months = [
      _t("Janar"),
      _t("Shkurt"),
      _t("Mars"),
      _t("Prill"),
      _t("Maj"),
      _t("Qershor"),
      _t("Korrik"),
      _t("Gusht"),
      _t("Shtator"),
      _t("Tetor"),
      _t("Nentor"),
      _t("Dhjetor"),
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {
      Sot: [moment(), moment()],
      Dje: [moment().subtract(1, "days"), moment().subtract(1, "days")],
      2024: [moment("2024-01-01"), moment("2024-12-31").endOf("day")],
      2025: [moment("01 Jan 2025"), moment()],
    };

    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];
    today = yyyy + "-" + mm + "-" + dd;
    let startDate = today;
    let endDate = today;
    accountStartDate = startDate;
    accountEndDate = endDate;
    $("#myCalendar").daterangepicker(
      {
        ranges: ranges,
        alwaysShowCalendars: true,
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
        opens: "center",
        locale: {
          direction: "ltr",
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: "Apliko",
          cancelLabel: "Anulo",
          fromLabel: "Da",
          toLabel: "A",
          customRangeLabel: "Personalizzata",
          daysOfWeek: ["DI", "HA", "MA", "ME", "EN", "PR", "SH"],
          monthNames: months,
          firstDay: 1,
        },
      },
      async function (start, end, label) {
        let role = localStorage.getItem("role");
        console.log(
          "New date range selected: " +
            start.format("YYYY-MM-DD") +
            " to " +
            end.format("YYYY-MM-DD") +
            " (predefined range: " +
            label +
            ")"
        );
        let startDate = start.format("YYYY-MM-DD");
        let endDate = end.format("YYYY-MM-DD");
        accountStartDate = startDate;
        accountEndDate = endDate;

        renderBalance();

        $("body #accountBalanceTbl *").remove();
      }
    );

    $("body").on("change", "#accountAgentSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      renderBalance();

      $("body #accountBalanceTbl *").remove();
    });

    $("body").on("change", "#accountBalanceUserCoinSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });

    $("body").on("change", "#casinoAccountSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });

    renderBalance();
    setTimeout(() => {
      Utils.showLoader();
    }, 50);
  },
};

async function renderBalance() {
  Utils.showLoader();
  const id = $("#casinoAccountSelect").val();
  const userId = $("#accountAgentSelect").val();
  let totalBets = 0;
  let totalWinnings = 0;
  let totalReturn = 0;
  let totalPercentage = 0;
  let totalNet = 0;
  let totalJackpot = 0;
  let accountBalances;
  let typeLabel = "";
  let currency = $("#accountBalanceUserCoinSelect").val();
  if (id && id == 2) {
    if (userId) {
      accountBalances = await casinoBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency
      );
    } else {
      accountBalances = await casinoBalance(
        accountStartDate,
        accountEndDate,
        currency
      );
    }
  } else if (id && id == 1) {
    if (userId) {
      accountBalances = await accountBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency
      );
    } else {
      accountBalances = await accountBalance(
        accountStartDate,
        accountEndDate,
        currency
      );
    }
  } else if (id && id == 3) {
    if (userId) {
      accountBalances = await virtualBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency
      );
    } else {
      accountBalances = await virtualBalance(
        accountStartDate,
        accountEndDate,
        currency
      );
    }
  } else if (!id) {
    if (userId) {
      accountBalances = await allBalanceForChildren(
        accountStartDate,
        accountEndDate,
        userId,
        currency
      );
    } else {
      accountBalances = await allBalance(
        accountStartDate,
        accountEndDate,
        currency
      );
    }
  }
  let accountBalanceView = "";

  if (accountBalances && id) {
    if (accountBalances.length > 0) {
      accountBalances.forEach((accBalance) => {
        totalBets += parseFloat(accBalance.stake ? accBalance.stake : 0);
        totalWinnings += parseFloat(accBalance.win ? accBalance.win : 0);
        totalPercentage += parseFloat(
          accBalance.percentage ? accBalance.percentage : 0
        );
        totalReturn += parseFloat(
          accBalance.difference ? accBalance.difference : 0
        );
        totalNet += parseFloat(
          accBalance.difference ? accBalance.difference : 0
        );
        accountBalanceView =
          accountBalanceView + getAccountBalanceTemplate(accBalance, role);
      });
    } else {
      if (accountBalances.stake) {
        totalBets += parseFloat(
          accountBalances.stake ? accountBalances.stake : 0
        );
        totalWinnings += parseFloat(
          accountBalances.win ? accountBalances.win : 0
        );
        totalPercentage += parseFloat(
          accountBalances.percentage ? accountBalances.percentage : 0
        );
        totalReturn += parseFloat(
          accountBalances.difference ? accountBalances.difference : 0
        );
        totalNet += parseFloat(
          accountBalances.difference ? accountBalances.difference : 0
        );
        accountBalanceView =
          accountBalanceView + getAccountBalanceTemplate(accountBalances, role);
      }
    }
  }

  if (accountBalances && !id) {
    const uniqueTypes = [
      ...new Set(accountBalances.map((item) => item.type)),
    ].sort(function (x, y) {
      if (x == "sport") {
        return -1;
      }
      if (x == "casino") {
        return 1;
      }
      return 0;
    });
    for (let index = 0; index < uniqueTypes.length; index++) {
      let currentTotalBets = 0;
      let currentTotalWinnings = 0;
      let currentTotalPercentage = 0;
      let currentTotalReturn = 0;
      let currentTotalNet = 0;
      let currentTotalJackpot = 0;
      const type = uniqueTypes[index];
      const balances = accountBalances.filter((a) => a.type == type);
      accountBalanceView += `<div class="accountBalanceContentHeader bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md shadow-black py-1 w-full flex flex-wrap flex-row text-white items-center justify-center mt-10 first:mt-0 m-t-6"><span class="text-[14px] font-bold">${type.toUpperCase()}</span></div>`;
      if (balances) {
        balances.forEach((accBalance) => {
          typeLabel = accBalance.type;
          totalBets += parseFloat(accBalance.stake ? accBalance.stake : 0);
          currentTotalBets += parseFloat(
            accBalance.stake ? accBalance.stake : 0
          );
          totalWinnings += parseFloat(accBalance.win ? accBalance.win : 0);
          currentTotalWinnings += parseFloat(
            accBalance.win ? accBalance.win : 0
          );
          totalPercentage += parseFloat(
            accBalance.percentage ? accBalance.percentage : 0
          );
          currentTotalPercentage += parseFloat(
            accBalance.percentage ? accBalance.percentage : 0
          );
          currentTotalJackpot += parseFloat(
            accBalance.jackpot ? accBalance.jackpot : 0
          );
          totalJackpot += parseFloat(
            accBalance.jackpot ? accBalance.jackpot : 0
          );
          totalReturn += parseFloat(
            accBalance.difference ? accBalance.difference : 0
          );
          currentTotalReturn += parseFloat(
            accBalance.difference ? accBalance.difference : 0
          );
          totalNet += parseFloat(
            accBalance.difference ? accBalance.difference : 0
          );
          currentTotalNet += parseFloat(
            accBalance.difference ? accBalance.difference : 0
          );
          accountBalanceView =
            accountBalanceView + getAccountBalanceTemplate(accBalance, role);
        });
      }
      accountBalanceView += `
                <div class="accountBalanceContentHeader w-full grid grid-cols-5 py-1 mt-4 text-white bg-black/40 whiteColor ${
                  role != "User" && typeLabel == "sport"
                    ? ""
                    : "fiveColumnsHolder"
                }">
                    <span class="text-center text-[14px] text-[#ffff00]">Total</span>
                    <span class="text-center text-[14px]">${currentTotalBets.toFixed(
                      2
                    )}</span>
                    <span class="text-center text-[14px]">${currentTotalWinnings.toFixed(
                      2
                    )}</span>
                    <span class="text-center text-[14px]">${
                      typeLabel == "casino"
                        ? `${currentTotalJackpot.toFixed(2)}`
                        : "-"
                    }</span>
                    ${
                      role != "User" && typeLabel == "sport"
                        ? `<span class="text-center text-[14px]">${currentTotalPercentage.toFixed(
                            2
                          )}</span>`
                        : ""
                    }
                    ${
                      role != "User"
                        ? ` <span class="text-center text-[14px]">${currentTotalReturn.toFixed(
                            2
                          )}</span>`
                        : ""
                    }
                    ${
                      role == "User"
                        ? ` <span class="text-center text-[14px]">${currentTotalNet.toFixed(
                            2
                          )}</span>`
                        : ""
                    }
                </div>
            `;
    }
  }

  $("body #accountBalanceTbl").append(accountBalanceView);

  if (role != "user") {
    $("body #accountBalanceContentFooter").empty();
    $("body #accountBalanceContentFooter").append(`
            <span class="text-center">TOTAL</span>
            <span class="text-center">${totalBets.toFixed(2)}</span>
            <span class="text-center">${totalWinnings.toFixed(2)}</span>
            <span class="text-center">${totalJackpot.toFixed(2)}</span>
            ${
              role != "User"
                ? `<span class="text-center">${totalPercentage.toFixed(
                    2
                  )}</span>`
                : ""
            }
            ${
              role != "User"
                ? ` <span class="text-center">${totalReturn.toFixed(2)}</span>`
                : ""
            }
            ${
              role == "User"
                ? ` <span class="text-center">${totalNet.toFixed(2)}</span>`
                : ""
            }`);
  }

  $("body #accountBalanceTbl")
    .children(".accountBalanceContentHeader.m-t-6")
    .each(function (i, item) {
      $(`
            <div class="accountBalanceContentHeader mb-4 w-full grid grid-cols-5 text-white py-1 bg-black/40 whiteColor ${
              $(item).children("span").html().toLowerCase() == "sport"
                ? ""
                : "fiveColumnsHolder"
            }">
                ${
                  role != "User"
                    ? ` <span class="text-center text-[16px]">Info</span>`
                    : `<span class="text-center text-[16px]">*</span>`
                }
                <span class="text-center text-[16px]">Xhiro</span>
                <span class="text-center text-[16px]">Fitimi</span>
                <span class="text-center text-[16px]">Jackpot</span>
                ${
                  role != "User" &&
                  $(item).children("span").html().toLowerCase() == "sport"
                    ? `<span class="text-center text-[16px]">%</span>`
                    : ""
                }
                ${
                  role != "User"
                    ? ` <span class="text-center text-[16px]">Diferenca</span>`
                    : ""
                }
                ${
                  role == "User"
                    ? ` <span class="text-center text-[16px]">Diferenca</span>`
                    : ""
                }
            </div>`).insertAfter($(item));
    });

  Utils.hideLoader();
}

export default AccountBalance;
